import React, { createContext, useState, useContext, useRef } from 'react';
import AgoraProvider from '../components/Layout/AgoraProvider';
import { VideoCall } from '../components/Layout/VideoCall';

const VideoCallContext = createContext();

export const VideoCallProvider = ({ children }) => {
    const [callState, setCallState] = useState({
        open: false,
        appId: null,
        channel: null,
        token: null,
        uid: null,
        startWithVideoOff: false,
    });
    
    // Use ref to force new component instance for each call
    const callKeyRef = useRef(0);

    const startCall = ({ appId, channel, token, uid, startWithVideoOff = false }) => {
        console.log('📞 Starting video call via context');
        
        // Increment key to force new component instance
        callKeyRef.current += 1;
        
        setCallState({
            open: true,
            appId,
            channel,
            token,
            uid,
            startWithVideoOff,
        });
    };

    const endCall = async () => {
        console.log('🔴 Ending video call via context');
        
        // Reset state
        setCallState({
            open: false,
            appId: null,
            channel: null,
            token: null,
            uid: null,
            startWithVideoOff: false,
        });
        
        // Small delay to ensure cleanup completes
        await new Promise(resolve => setTimeout(resolve, 500));
        
        console.log('✅ Video call context cleanup complete');
    };

    return (
        <VideoCallContext.Provider value={{ startCall, endCall }}>
            {children}
            {callState.open && (
                <AgoraProvider key={`video-call-${callKeyRef.current}`}>
                    <VideoCall
                        appId={callState.appId}
                        channel={callState.channel}
                        token={callState.token}
                        uid={callState.uid}
                        open={callState.open}
                        onClose={endCall}
                        startWithVideoOff={callState.startWithVideoOff}
                    />
                </AgoraProvider>
            )}
        </VideoCallContext.Provider>
    );
};

export const useVideoCall = () => {
    const context = useContext(VideoCallContext);
    if (!context) {
        throw new Error('useVideoCall must be used within VideoCallProvider');
    }
    return context;
};